import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CertificatesTabComponent } from './certificatesTab.component';
import { ButtonModule } from '@app/components/button/button.module';
import { TranslateModule } from '@ngx-translate/core';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';
import { CertificateModule } from '@app/profile/certificatesTab/certificate/certificate.module';
import { LoaderModule } from '@shared/loader/loader.module';

@NgModule({
  imports: [CommonModule, ButtonModule, TranslateModule, PlIconModule, CertificateModule, LoaderModule],
  declarations: [CertificatesTabComponent],
  exports: [CertificatesTabComponent],
})
export class CertificatesTabModule {}
